import { Dialog, IconButton } from "@mui/material";
import { AlignLeft, FileText, X } from "lucide-react";
import "./FormModal.css";
import "./PlanDescriptionModal.css";

/**
 * Shared “view full description” dialog for plan listing pages.
 */
const PlanDescriptionModal = ({
  open,
  handleClose,
  description,
  title = "Plan description",
  planName,
}) => {
  const body =
    description && description !== "N/A"
      ? description
      : "No description available for this plan.";
  const hasDescription = Boolean(description && description !== "N/A");

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      fullWidth
      maxWidth="sm"
      PaperProps={{ className: "fm-dialog pdm-dialog" }}
    >
      <div className="fm-header">
        <div className="fm-header-icon" aria-hidden>
          <AlignLeft size={20} strokeWidth={2} />
        </div>
        <div className="fm-header-copy">
          <h2>{title}</h2>
          <p>
            {planName
              ? `Full details for ${planName}`
              : "Full plan details from the listing"}
          </p>
        </div>
        <IconButton
          className="fm-close"
          onClick={handleClose}
          aria-label="Close"
          size="small"
        >
          <X size={18} strokeWidth={2} />
        </IconButton>
      </div>

      <div className="fm-body pdm-body">
        <div className={`pdm-content ${hasDescription ? "" : "is-empty"}`}>
          {!hasDescription ? (
            <div className="pdm-empty">
              <FileText size={28} strokeWidth={1.6} aria-hidden />
              <p>{body}</p>
            </div>
          ) : (
            <p className="pdm-text">{body}</p>
          )}
        </div>
      </div>

      <div className="fm-footer">
        <button type="button" className="fm-btn is-primary" onClick={handleClose}>
          Close
        </button>
      </div>
    </Dialog>
  );
};

export default PlanDescriptionModal;
